import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';
import Tenant from '../ts/Tenant';

export const actions: ActionTree<any, any> = {

    getData: ({state, getters, commit, dispatch}, force) => {

        if (force) state.tenantsExpire = null;

        // Pull from store if loaded and cache hasn't expired
        if (state.tenantsExpire && moment().isBefore(state.tenantsExpire)) {
            return state.tenants;
        }

        commit('setLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/tenants')

                .then(({data}) => {
                    commit('setData', data.tenants);
                    commit('setLoading', false);
                    resolve(null);
                })
                .catch(error => {

                    commit('setLoading', false);
                    reject(error);
                });
        });
    },

    createTenant: ({state, getters, commit, dispatch}, data) => {

        commit('setSaving', true);

        return new Promise((resolve, reject) => {

            axios.put('/tenant', data)

                .then((response) => {
                    commit('addTenant', response.data.tenant);
                    commit('setSaving', false);
                    resolve(response);
                })
                .catch(({response}) => {
                    commit('setSaving', false);
                    reject(response);
                });
        })
    },

    updateTenant: ({state, getters, commit, dispatch}, tenant: Tenant) => {

        let found = state.tenants.find((t: Tenant) => t.uuid === tenant.uuid);
        let backupTenant = Object.assign({}, found);

        commit('setSaving', true);

        return new Promise((resolve, reject) => {

            commit('updateTenant', tenant);

            axios.post('/tenant', tenant)

                .then(({data}) => {
                    commit('setSaving', false);
                    resolve(null);
                })
                .catch(({response}) => {
                    commit('updateTenant', backupTenant);
                    commit('setSaving', false);
                    reject(response);
                })
        });
    },

    deleteTenant: ({state, getters, commit, dispatch}, tenant: Tenant) => {

        let found = state.tenants.find((t: Tenant) => t.uuid === tenant.uuid);
        let backupTenant = Object.assign({}, found);

        return new Promise((resolve, reject) => {

            commit('deleteTenant', tenant);

            axios.delete('/tenant/' + tenant.uuid)

                .then(({data}) => {
                    resolve(null);
                })
                .catch(({response}) => {
                    commit('addTenant', backupTenant);
                    reject(response);
                })
        });
    },

    loadTenantFeatures: ({state, getters, commit, dispatch}, uuid) => {

        return new Promise((resolve, reject) => {

            axios.get('/tenant/' + uuid + '/features')

                .then(response => {

                    commit('setTenantFeatures', {uuid: uuid, features: response.data.features});
                    commit('setAvailableFeatures', response.data.available);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    saveTenantFeatures: ({state, getters, commit, dispatch}, {uuid, features}) => {

        return new Promise((resolve, reject) => {

            axios.put('/tenant/' + uuid + '/features', {features: features})

                .then(response => {
                    commit('setTenantFeatures', {uuid: uuid, features: features});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
};
